import gql from 'graphql-tag'
import { ProfileFragmentGQL } from './fragments'

export const OrdersGQL = gql`
  query orders($params: OrdersFilter!) {
    merchant {
      orders(params: $params) {
        content {
          id
          amount
          awardAggregator
          awardAmount
          canChangeStatus
          statusReason
          partnerApproved
          check {
            amount
            checkDate
            currency
            deviceUid
            fn
            number
            sourceQr
            manual
          }
          orderedAt
          currency
          currencyPartnerCommission
          source
          status
          orderType
          user {
            firstName
            lastName
            patronymic
            approvedOrders
            declinedOrders
            externalUserId
            email
          }
        }
        currentPage
        totalElements
        totalPages
      }
    }
  }
`

export const ManagerGQL = gql`
  query manager {
    merchant {
      defaultContractId
      manager {
        partnerContractList {
          id
          currency
          activeFrom
          activeTo
          balance
          number
          externalGuid
          partnerEntity {
            name
            inn
            currency
          }
        }
        partnerAccessList {
          access
          role
        }
      }
    }
  }
`

export const DefaultContractIdGQL = gql`
    query defaultContractId {
      merchant {
        defaultContractId
      }
    }
`

export const MerchantCurrencyGQL = gql`
  query merchantCurrency {
    merchant {
      currency
    }
  }
`

export const PaymentsGQL = gql`
    query payments($params: PaymentsFilter!) {
      merchant {
        payments(params: $params) {
          content {
            id
            operationType
            url
            documentType
            date
            currency
            amount
          }
          currentPage
          totalElements
          totalPages
        }
      }
    }
`

export const SettlementsGQL = gql`
    query settlements($params: SettlementsFilter!) {
      merchant {
        settlements (params: $params) {
            clientOrdersApprovedCount
            clientOrdersCheckCount
            clientOrdersPendingCount
            clientOrdersRequireAction
            dateLastBillShop
            forecastBalance
            forecastDeposit
            minDepositAmount
            partnerContract {
              balance
              currency
              partnerEntity {
                inn
                name
              }
            }
            billInfo {
                count
                amount
            }
        }
      }
    }
`

export const BillsGQL = gql`
    query bills( $params: BillsFilter! ) {
        merchant {
          bills (params: $params) {
            content {
              amount
              commission
              currency
              date
              debtAmount
              id
              payAmount
              recharge
              status
              url
              number
            }
            currentPage
            totalElements
            totalPages
          }
        }
    }
`

export const MeGQL = gql`
  query Me {
    me {
      id
      availableMerchants {
        draft
        id
        merchantId
        slug
        currency
        reqCompanyRegistrationDate
      }
    }
  }
`
export const ReqCountriesGQL = gql`
    query ReqCountries {
      commonData {
        ReqCountries {
          code
          currency
          id
          name
        }
      }
    }
`

export const CategoriesGQL = gql`
    query Categories {
      commonData {
        Categories {
          id
          translationList {
            condition
            description
            id
            locale
            name
          }
        }
      }
    }
`

export const CitiesGQL = gql`
    query Cities(
      $cityName: String!
      $countryIds: [Int!]!
    ) {
      commonData {
        Cities(params: {cityName: $cityName, countryIds: $countryIds}) {
          id
          name
        }
      }
    }
`

export const CountriesGQL = gql`
    query Countries {
      commonData {
        Countries {
          code
          currency
          id
          name
        }
      }
    }
`

export const UserFioByLoginGQL = gql`
  query UserFioByLogin( $login: String! ) {
    commonData {
      UserFioByLogin (params: {
        login: $login
      })
    }
  }
`

export const EgrulDataGQL = gql`
  query EgrulData( $inn: String! ) {
    commonData {
      EgrulData (params: {
        inn: $inn
      }) {
        email
        reqCompanyDirector
        reqCompanyRegistrationDate
        reqContactPhone
        reqInn
        reqKpp
        reqLegalAddress
        reqLegalName
        reqOgrn
        reqOkved
      }
    }
  }
`

export const SummaryStatGQL = gql`
  query SummaryStat($params: StatsFilter) {
    merchant {
      stats {
        summary (params: $params) {
          amountMonth
          amountPrevDate
          amountPrevMonth
          amountToday
          totalAmount
        }
      }
    }
  }
`

export const ChartStatGQL = gql`
  query ChartStat($params: ChartFilter) {
    merchant {
      stats {
        chart (params: $params) {
          commission
          startDate
          endDate
        }
      }
    }
  }
`

export const PlaceAutocompleteGQL = gql`
  query PlaceAutocomplete ( $input: String! ) {
    commonData {
      PlaceAutocomplete (input: $input) {
        predictions {
          description
        }
      }
    }
  }
`

export const ResponseQrGQL = gql`
  query ResponseQr ($params: ResponseQr) {
    merchant {
      qr {
        responseQr (params: $params)
      }
    }
  }
`

export const TerminalsGQL = gql`
    query Terminals ($params: PageTerminalFilter!) {
      merchant {
        terminals(params: $params) {
          content {
            active
            address
            id
            number
            shopId
            shopName
            terminalType
          }
          currentPage
          totalElements
          totalPages
        }
      }
    }
`

export const ReceiptQrGQL = gql`
  query ReceiptQr ($params: ReceiptQr) {
    merchant {
      qr {
        receiptQr (params: $params)
      }
    }
  }
`

export const ProfileGQL = gql`
  query Profile {
    merchant {
      profile {
        ...ProfileFragment
      }
    }
  }
  ${ProfileFragmentGQL}
`

export const WhiteListDomainsGQL = gql`
  query WhiteListDomains {
    merchant {
      integration {
        tilda {
          whiteListDomains {
            crm
            domain
            id
          }
        }
      }
    }
  }
`

export const ManagerListGQL = gql`
    query ManagerList {
      merchant {
        managerList {
          id
          email
          login
          name
          owner
          phone
          isActive
          managerAccess {
            partnerAccessList {
              access
              role
            }
          }
        }
      }
    }
`

export const IntegrationGQL = gql`
  query Integration {
    merchant {
      integration {
        apiKey
      }
    }
  }
`

export const ReferralsGQL = gql`
    query Referrals ($params: ReferralListInput!) {
      merchant {
        referrals(params: $params) {
          content {
            approvedOrders
            createdAt
            createdByManagerLogin
            declinedOrders
            email
            externalUserId
            firstName
            id
            lastName
            login
            patronymic
            phone
          }
          currentPage
          totalElements
          totalPages
        }
      }
    }
`

export const StaticDocumentsGQL = gql`
  query StaticDocuments {
    merchant {
        staticDocuments {
          content
          date
          downloadUrl
          iframe
          show {
            countries
            exceptCountries
            exceptPartners
            gold
            partners
          }
        }
    }
  }
`

export const StaticNotificationsGQL = gql`
  query StaticNotifications {
    merchant {
      notifications{
        staticNotifications{
          id
          content{
            title
            key
            description
            body
          }
          date
          show{
            countries
            exceptCountries
            partners
            exceptPartners
            specialRules{
              prop
              value
            }
          }
        }
      }
    }
  }
`

export const PinCodeTokenGQL = gql`
    query PinCodeToken ($params: PinCodeTokenParams!) {
      pinCodeToken (params: $params)
    }
`
